import React, { useState, useRef, useEffect } from "react";
import QRCode from "react-qr-code";
import Button from "@mui/material/Button";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import IconButton from "@mui/material/IconButton";
import DownloadIcon from "@mui/icons-material/Download";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import configs, { getParameterByName } from "../Constants";
import html2pdf from 'html2pdf.js';
import "./QRCodes.css"

function QRCodes() {
  const [logo, setLogo] = useState("");
  const contentRef = useRef(null);
  let merchantData = localStorage.getItem("merchantData") ? JSON.parse(localStorage.getItem("merchantData")) : null;

  const merchCode = merchantData && merchantData.merchantCode;

  const configs = JSON.parse(localStorage.getItem("configs"));

  // configs.productName
  const sokQR = `${configs.sokUrl}?merchantCode=${merchCode}&isScan=true`;
  const emenu = `${configs.emenuUrl}?merchantCode=${merchCode}&isScan=true`;
  const onlineQR = `${configs.ttoUrl.replace('tto','online')}?merchantCode=${merchCode}&isScan=true`;
  const kot = `https://signage-common-assets.s3.ap-south-1.amazonaws.com/plugins/kitchen-side-token/tokens.html?serve_url=${configs.baseURL}&merchantCode=${merchCode}`;
  const waiterQR = `https://signage-common-assets.s3.ap-south-1.amazonaws.com/plugins/waiter-token/tokens.html?serve_url=${configs.baseURL}&merchantCode=${merchCode}`;
  const ecomQR = `https://ecom.menulive.in?merchantCode=${merchCode}`;

  // Debug: URLs check in Console
  useEffect(() => {
    console.log("=== QR CODE DEBUG ===");
    console.log("Configs:", configs);
    console.log("\nGenerated URLs:");
    console.log("1. sokQR:", sokQR);
    console.log("2. emenu:", emenu);
    console.log("3. onlineQR:", onlineQR);
    console.log("4. kot:", kot);
    console.log("5. waiterQR:", waiterQR);
    console.log("\nURL Properties:");
    console.log("sokUrl exists:", !!configs.sokUrl);
    console.log("emenuUrl exists:", !!configs.emenuUrl);
    console.log("ttoUrl exists:", !!configs.ttoUrl);
    console.log("onlineUrl exists:", !!configs.onlineUrl);
    console.log("===================");
  }, []);

  let companyLogo = "/images/logo.png";

  function base64Converter(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      }
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }

  base64Converter(merchantData ? merchantData.logoImg : "", function (dataUrl) {
    setLogo(dataUrl);
  })

  const handleDownload = () => {
    const element = document.getElementById("qr-img1");
    const down_logo = document.getElementById("download_logo1")
    down_logo.style.visibility = "hidden";
    html2canvas(element).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const scaleFactor = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);

      const x = (pdfWidth - imgWidth * scaleFactor) / 2;
      const y = (pdfHeight - imgHeight * scaleFactor) / 2;

      pdf.addImage(imgData, 'PNG', x, y, imgWidth * scaleFactor, imgHeight * scaleFactor);
      pdf.save("self-order-qrcode.pdf");
      down_logo.style.visibility = "visible";
    });
  };

  const handleDownload1 = () => {
    const element = document.getElementById("qr-img2");
    const down_logo = document.getElementById("download_logo2")
    down_logo.style.visibility = "hidden";
    html2canvas(element).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const scaleFactor = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);

      const x = (pdfWidth - imgWidth * scaleFactor) / 2;
      const y = (pdfHeight - imgHeight * scaleFactor) / 2;

      pdf.addImage(imgData, 'PNG', x, y, imgWidth * scaleFactor, imgHeight * scaleFactor);
      pdf.save("emenu-qrcode.pdf");
      down_logo.style.visibility = "visible";
    });
  };

  const handleDownload2 = () => {
    const element = document.getElementById("qr-img3");
    const down_logo = document.getElementById("download_logo3")
    down_logo.style.visibility = "hidden";
    html2canvas(element).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const scaleFactor = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);

      const x = (pdfWidth - imgWidth * scaleFactor) / 2;
      const y = (pdfHeight - imgHeight * scaleFactor) / 2;

      pdf.addImage(imgData, 'PNG', x, y, imgWidth * scaleFactor, imgHeight * scaleFactor);
      pdf.save("kitchen-qrcode.pdf");
      down_logo.style.visibility = "visible";
    });
  };

  const handleDownload3 = () => {
    const element = document.getElementById("qr-img4");
    const down_logo = document.getElementById("download_logo4")
    down_logo.style.visibility = "hidden";
    html2canvas(element).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const scaleFactor = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);

      const x = (pdfWidth - imgWidth * scaleFactor) / 2;
      const y = (pdfHeight - imgHeight * scaleFactor) / 2;

      pdf.addImage(imgData, 'PNG', x, y, imgWidth * scaleFactor, imgHeight * scaleFactor);
      pdf.save("online-order-qrcode.pdf");
      down_logo.style.visibility = "visible";
    });
  };

  const handleDownload4 = () => {
    const element = document.getElementById("qr-img5");
    const down_logo = document.getElementById("download_logo5")
    down_logo.style.visibility = "hidden";
    html2canvas(element).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const scaleFactor = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);

      const x = (pdfWidth - imgWidth * scaleFactor) / 2;
      const y = (pdfHeight - imgHeight * scaleFactor) / 2;

      pdf.addImage(imgData, 'PNG', x, y, imgWidth * scaleFactor, imgHeight * scaleFactor);
      pdf.save("waiter-qrcode.pdf");
      down_logo.style.visibility = "visible";
    });
  };

  const handleDownloadEcom = () => {
    const element = document.getElementById("qr-img-ecom");
    const down_logo = document.getElementById("download_logo_ecom")
    down_logo.style.visibility = "hidden";
    html2canvas(element).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const scaleFactor = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);

      const x = (pdfWidth - imgWidth * scaleFactor) / 2;
      const y = (pdfHeight - imgHeight * scaleFactor) / 2;

      pdf.addImage(imgData, 'PNG', x, y, imgWidth * scaleFactor, imgHeight * scaleFactor);
      pdf.save("ecom-qrcode.pdf");
      down_logo.style.visibility = "visible";
    });
  };

  return (
    <div style={{ width: "100%", display: "flex", flexWrap: "wrap", justifyContent: "center", overflow: "auto", height: "87vh" }}>

      <div
        id="qr-img1"
        className="downloadQR"
        ref={contentRef}
        style={{
          background: 'linear-gradient(135deg, #f12711 0%, #f5af19 100%)',
          borderRadius: '16px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          color: '#fff',
          position: 'relative',
          padding: '20px',
          boxSizing: 'border-box',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '40px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <img src="/images/eat_in.png" alt="" style={{ width: '32px', height: '32px', objectFit: 'contain' }} />
            <span style={{ fontSize: '18px', fontWeight: 'bold', letterSpacing: '1px', textTransform: 'uppercase' }}>Self Order</span>
          </div>
          <FileDownloadIcon
            fontSize="large"
            color="primary"
            id="download_logo1"
            cursor="pointer"
            onClick={handleDownload}
            style={{ filter: 'drop-shadow(0px 2px 5px rgba(0,0,0,0.3))' }}
          />
        </div>

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '15px' }}>
          <div style={{ color: '#e0e0e0', fontSize: '14px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '1.5px' }}>
            Scan to Place Your Order
          </div>
          <div style={{
            background: '#fff',
            padding: '16px',
            borderRadius: '16px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {sokQR && (
              <QRCode
                size={220}
                value={sokQR}
                style={{ height: '220px', width: '220px' }}
              />
            )}
          </div>
        </div>

        <div className="logos" style={{ marginTop: 'auto', borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '15px' }}>
          {logo && <img src={logo} alt="Logo" style={{ width: '90px', maxHeight: '50px', objectFit: 'contain' }} />}
          <div style={{ textAlign: 'left' }}>
            <span style={{ color: '#b0bec5', fontSize: '12px', display: 'block', fontStyle: 'italic' }}>Powered by</span>
            <h5 style={{ color: '#fff', fontSize: '20px', margin: '0px', fontWeight: 'bold' }}>{configs.productName}</h5>
          </div>
        </div>
      </div>

      <div
        id="qr-img2"
        className="downloadQR"
        style={{
          background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
          borderRadius: '16px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          color: '#fff',
          position: 'relative',
          padding: '20px',
          boxSizing: 'border-box',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '40px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <img src="/images/take-out-2.png" alt="" style={{ width: '32px', height: '32px', objectFit: 'contain' }} />
            <span style={{ fontSize: '18px', fontWeight: 'bold', letterSpacing: '1px', textTransform: 'uppercase' }}>E-Menu</span>
          </div>
          <FileDownloadIcon
            fontSize="large"
            color="primary"
            id="download_logo2"
            cursor="pointer"
            onClick={handleDownload1}
            style={{ filter: 'drop-shadow(0px 2px 5px rgba(0,0,0,0.3))' }}
          />
        </div>

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '15px' }}>
          <div style={{ color: '#e0e0e0', fontSize: '14px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '1.5px' }}>
            Scan to View Digital Menu
          </div>
          <div style={{
            background: '#fff',
            padding: '16px',
            borderRadius: '16px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {emenu && (
              <QRCode
                size={220}
                value={emenu}
                style={{ height: '220px', width: '220px' }}
              />
            )}
          </div>
        </div>

        <div className="logos" style={{ marginTop: 'auto', borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '15px' }}>
          {logo && <img src={logo} alt="Logo" style={{ width: '90px', maxHeight: '50px', objectFit: 'contain' }} />}
          <div style={{ textAlign: 'left' }}>
            <span style={{ color: '#b0bec5', fontSize: '12px', display: 'block', fontStyle: 'italic' }}>Powered by</span>
            <h5 style={{ color: '#fff', fontSize: '20px', margin: '0px', fontWeight: 'bold' }}>{configs.productName}</h5>
          </div>
        </div>
      </div>

      <div
        id="qr-img3"
        className="downloadQR"
        style={{
          background: 'linear-gradient(135deg, #cb2d3e 0%, #ef473a 100%)',
          borderRadius: '16px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          color: '#fff',
          position: 'relative',
          padding: '20px',
          boxSizing: 'border-box',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '40px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <img src="/images/logo.png" alt="" style={{ width: '32px', height: '32px', objectFit: 'contain', filter: 'brightness(0) invert(1)' }} />
            <span style={{ fontSize: '18px', fontWeight: 'bold', letterSpacing: '1px', textTransform: 'uppercase' }}>Kitchen Side</span>
          </div>
          <FileDownloadIcon
            fontSize="large"
            color="primary"
            id="download_logo3"
            cursor="pointer"
            onClick={handleDownload2}
            style={{ filter: 'drop-shadow(0px 2px 5px rgba(0,0,0,0.3))' }}
          />
        </div>

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '15px' }}>
          <div style={{ color: '#e0e0e0', fontSize: '14px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '1.5px' }}>
            Scan to Manage Kitchen Tokens
          </div>
          <div style={{
            background: '#fff',
            padding: '16px',
            borderRadius: '16px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {kot && (
              <QRCode
                size={220}
                value={kot}
                style={{ height: '220px', width: '220px' }}
              />
            )}
          </div>
        </div>

        <div className="logos" style={{ marginTop: 'auto', borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '15px' }}>
          {logo && <img src={logo} alt="Logo" style={{ width: '90px', maxHeight: '50px', objectFit: 'contain' }} />}
          <div style={{ textAlign: 'left' }}>
            <span style={{ color: '#b0bec5', fontSize: '12px', display: 'block', fontStyle: 'italic' }}>Powered by</span>
            <h5 style={{ color: '#fff', fontSize: '20px', margin: '0px', fontWeight: 'bold' }}>{configs.productName}</h5>
          </div>
        </div>
      </div>

      <div
        id="qr-img4"
        className="downloadQR"
        style={{
          background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
          borderRadius: '16px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          color: '#fff',
          position: 'relative',
          padding: '20px',
          boxSizing: 'border-box',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '40px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <img src="/images/delivery.png" alt="" style={{ width: '32px', height: '32px', objectFit: 'contain' }} />
            <span style={{ fontSize: '18px', fontWeight: 'bold', letterSpacing: '1px', textTransform: 'uppercase' }}>Online Order</span>
          </div>
          <FileDownloadIcon
            fontSize="large"
            color="primary"
            id="download_logo4"
            cursor="pointer"
            onClick={handleDownload3}
            style={{ filter: 'drop-shadow(0px 2px 5px rgba(0,0,0,0.3))' }}
          />
        </div>

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '15px' }}>
          <div style={{ color: '#e0e0e0', fontSize: '14px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '1.5px' }}>
            Scan to Order Online
          </div>
          <div style={{
            background: '#fff',
            padding: '16px',
            borderRadius: '16px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {onlineQR && (
              <QRCode
                size={220}
                value={onlineQR}
                style={{ height: '220px', width: '220px' }}
              />
            )}
          </div>
        </div>

        <div className="logos" style={{ marginTop: 'auto', borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '15px' }}>
          {logo && <img src={logo} alt="Logo" style={{ width: '90px', maxHeight: '50px', objectFit: 'contain' }} />}
          <div style={{ textAlign: 'left' }}>
            <span style={{ color: '#b0bec5', fontSize: '12px', display: 'block', fontStyle: 'italic' }}>Powered by</span>
            <h5 style={{ color: '#fff', fontSize: '20px', margin: '0px', fontWeight: 'bold' }}>{configs.productName}</h5>
          </div>
        </div>
      </div>

      <div
        id="qr-img5"
        className="downloadQR"
        style={{
          background: 'linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)',
          borderRadius: '16px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          color: '#fff',
          position: 'relative',
          padding: '20px',
          boxSizing: 'border-box',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '40px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <img src="/images/waiter.png" alt="" style={{ width: '32px', height: '32px', objectFit: 'contain' }} />
            <span style={{ fontSize: '18px', fontWeight: 'bold', letterSpacing: '1px', textTransform: 'uppercase' }}>Waiter Token</span>
          </div>
          <FileDownloadIcon
            fontSize="large"
            color="primary"
            id="download_logo5"
            cursor="pointer"
            onClick={handleDownload4}
            style={{ filter: 'drop-shadow(0px 2px 5px rgba(0,0,0,0.3))' }}
          />
        </div>

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '15px' }}>
          <div style={{ color: '#e0e0e0', fontSize: '14px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '1.5px' }}>
            Scan to Access Waiter Panel
          </div>
          <div style={{
            background: '#fff',
            padding: '16px',
            borderRadius: '16px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {waiterQR && (
              <QRCode
                size={220}
                value={waiterQR}
                style={{ height: '220px', width: '220px' }}
              />
            )}
          </div>
        </div>

        <div className="logos" style={{ marginTop: 'auto', borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '15px' }}>
          {logo && <img src={logo} alt="Logo" style={{ width: '90px', maxHeight: '50px', objectFit: 'contain' }} />}
          <div style={{ textAlign: 'left' }}>
            <span style={{ color: '#b0bec5', fontSize: '12px', display: 'block', fontStyle: 'italic' }}>Powered by</span>
            <h5 style={{ color: '#fff', fontSize: '20px', margin: '0px', fontWeight: 'bold' }}>{configs.productName}</h5>
          </div>
        </div>
      </div>

      <div
        id="qr-img-ecom"
        className="downloadQR"
        style={{
          background: 'linear-gradient(135deg, #833ab4 0%, #fd1d1d 50%, #fcb045 100%)',
          borderRadius: '16px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          color: '#fff',
          position: 'relative',
          padding: '20px',
          boxSizing: 'border-box',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '40px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <img src="/images/delivery.png" alt="" style={{ width: '32px', height: '32px', objectFit: 'contain' }} />
            <span style={{ fontSize: '18px', fontWeight: 'bold', letterSpacing: '1px', textTransform: 'uppercase' }}>eCommerce</span>
          </div>
          <FileDownloadIcon
            fontSize="large"
            color="primary"
            id="download_logo_ecom"
            cursor="pointer"
            onClick={handleDownloadEcom}
            style={{ filter: 'drop-shadow(0px 2px 5px rgba(0,0,0,0.3))' }}
          />
        </div>

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '15px' }}>
          <div style={{ color: '#e0e0e0', fontSize: '14px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '1.5px' }}>
            Scan for E-Commerce App
          </div>
          <div style={{
            background: '#fff',
            padding: '16px',
            borderRadius: '16px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {ecomQR && (
              <QRCode
                size={220}
                value={ecomQR}
                style={{ height: '220px', width: '220px' }}
              />
            )}
          </div>
        </div>

        <div className="logos" style={{ marginTop: 'auto', borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '15px' }}>
          {logo && <img src={logo} alt="Logo" style={{ width: '90px', maxHeight: '50px', objectFit: 'contain' }} />}
          <div style={{ textAlign: 'left' }}>
            <span style={{ color: '#b0bec5', fontSize: '12px', display: 'block', fontStyle: 'italic' }}>Powered by</span>
            <h5 style={{ color: '#fff', fontSize: '20px', margin: '0px', fontWeight: 'bold' }}>{configs.productName}</h5>
          </div>
        </div>
      </div>

    </div>
  );
}

export default QRCodes;